//This file is automatically rebuilt by the Cesium build process.
export default "/**\n\
 * 0.01\n\
 *\n\
 * @name czm_epsilon2\n\
 * @glslConstant\n\
 */\n\
const float czm_epsilon2 = 0.01;\n\
";